import { FileTypeEnum as e } from "../enums/file-type-enum.mjs";
import t from "../icons/audio-file-icon.mjs";
import n from "../icons/document-file-icon.mjs";
import r from "../icons/image-file-icon.mjs";
import i from "../icons/video-file-icon.mjs";
import "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/utils/get-thumbnail-by-type.tsx
function o(o) {
	switch (o) {
		case e.Audio: return /* @__PURE__ */ a(t, {
			"aria-hidden": !0,
			className: "text-icon-secondary size-10 fill-current"
		});
		case e.Image:
		case e.ImageOther: return /* @__PURE__ */ a(r, {
			"aria-hidden": !0,
			className: "text-icon-secondary size-10 fill-current"
		});
		case e.Video: return /* @__PURE__ */ a(i, {
			"aria-hidden": !0,
			className: "text-icon-secondary size-10 fill-current"
		});
		case e.Font:
		case e.Document: return /* @__PURE__ */ a(n, {
			"aria-hidden": !0,
			className: "text-icon-secondary size-10 fill-current"
		});
		default: return /* @__PURE__ */ a(n, {
			"aria-hidden": !0,
			className: "text-icon-secondary size-10 fill-current"
		});
	}
}
//#endregion
export { o as getThumbnailByType };
